import { setCookie } from "../../Common/ts/appTools";

type CookieOptions = {
    name: string;
    value: string;
    days?: number;
    path?: string;
};

type CookieSetter = (options: CookieOptions) => void;

export function setLocalPreviewLoginCookies(
    setCookieImpl: CookieSetter = setCookie,
) {
    setCookieImpl({name: "token", value: "preview", days: 0});
    setCookieImpl({name: "user_type", value: "C", days: 0});
}
